import { DEALERS_API_URL, INTEGRATIONS_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';

/**
 * @param {string} dealerId
 * @param {string} integration
 * @param {Object} [meta={}]
 * @returns {import('../types').SubscribeIntegrationAction}
 */
export const subscribeIntegration = (dealerId, integration, meta = {}) => ({
  type: types.SUBSCRIBE_INTEGRATION,
  payload: {
    request: {
      method: 'POST',
      url: `${DEALERS_API_URL}/${dealerId}${INTEGRATIONS_URL[integration]}/configure`,
    },
    dealerId,
  },
  meta,
});

/**
 * @param {string} dealerId
 * @param {Object} [meta={}]
 * @returns {import('../types').SubscribeIntegrationSuccessAction}
 */
export const subscribeIntegrationSuccess = (dealerId, meta = {}) => ({
  type: types.SUBSCRIBE_INTEGRATION_SUCCESS,
  payload: { dealerId },
  meta,
});

/**
 * @param {string} error
 * @param {Object} [meta={}]
 * @returns {import('../types').SubscribeIntegrationFailureAction}
 */
export const subscribeIntegrationFailure = (error, meta = {}) => ({
  type: types.SUBSCRIBE_INTEGRATION_FAILURE,
  payload: error,
  error: true,
  meta,
});
